export default {
  contacts: {
    results: [],
    count: 0,
  },
  contacts2: {
    results: [],
    count: 0,
  },
  allContacts: {},
  allagents: {
    results: [],
  },
  contactsCard: {
    next: 0,
    results: [],
  },
  reportList: {
    results: []
  },
  reportOne: {},
  allContactContracts: [],
  tabProvidersOrBuyers: 0
}
